import { render } from "./wzMultiSelect.vue?vue&type=template&id=3dcc356e&scoped=true"
import script from "./wzMultiSelect.vue?vue&type=script&lang=js"
export * from "./wzMultiSelect.vue?vue&type=script&lang=js"

import "./wzMultiSelect.vue?vue&type=style&index=0&id=3dcc356e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dcc356e"]])

export default __exports__